import React from 'react'
import { useIntl } from 'react-intl'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import PageBanner from 'LuxKit/Banners/PageBanner'

interface Props {
  className?: string
}

const AtolProtectedBanner = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className } = props
  const intl = useIntl()

  return <PageBanner
    ref={ref}
    className={className}
    kind="informational-primary"
    align="center"
    icon={<img src={getSVGImageUrl('984lj4elpskyg828z90qb')} width="16" height="16" alt="" />}
  >
    {intl.formatMessage(
      {
        id: 'f3QcmvhhtJ',
        defaultMessage: 'ATOL protected',
        description: 'ATOL protection banner message in the insurance or protection selection',
      },
    )}
  </PageBanner>
})

export default AtolProtectedBanner
